<template>
    <div class="row">
        <div class="panel panel-primary">
            <div class="panel-heading">
                <h3 class="panel-title">Event Jobs</h3>
            </div>
            <table class="table table-bordered table-striped table-condensed">
                <thead>
                    <tr>
                        <th>Job</th>
                        <th>Timeslot</th>
                        <th>Number Required</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <template v-for="(eventJob, index) in eventJobs">
                        <tr v-for="(timeslot, timeslotIndex) in eventJob.club_event_job_timeslots">
                            <td
                                v-if="timeslotIndex === 0"
                                :rowspan="eventJob.club_event_job_timeslots.length"
                            >
                                <span class="h5">{{ eventJob.job_name }}</span><br />{{ eventJob.description }}
                            </td>
                            <td>{{ timeslot.timeslot_name }} ({{ timeslot.hours }}h)</td>
                            <td>{{ numberOfMembersRequired(timeslot) }}</td>
                            <td>
                                <button v-if="!timeslot.joined && eventJob.allow_signup && membersRequired(timeslot)" @click="join(timeslot.id)" class="btn btn-sm btn-success">Sign Up</button>
                                <button v-if="timeslot.joined" @click="unjoin(timeslot.id)" class="btn btn-sm btn-danger">Leave</button>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
    export default {
        props: [
            'eventId'
        ],

        data: function () {
            return {
                eventJobs: []
            }
        },

        mounted() {
            this.getEventJobs();
        },

        methods: {
            getEventJobs() {
                axios.get(`/api/v1/club_events/${this.eventId}/volunteers`).then((response) => {
                    this.eventJobs = response.data;
                }).catch((error) => {
                    this.$message({message: 'There was a problem loading event volunteers.', type: 'error'});
                });
            },

            join(timeslotId) {
                axios.post(`/api/v1/timeslots/${timeslotId}/join`)
                    .then(response => {
                        this.getEventJobs();
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem while joining to event.', type: 'error'});
                    });
            },

            unjoin(timeslotId) {
                axios.delete(`/api/v1/timeslots/${timeslotId}/unjoin`)
                    .then(response => {
                        this.getEventJobs();
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem while unjoinig to event.', type: 'error'});
                    });
            },

            membersRequired(timeslot) {
                console.log(timeslot.number_required > timeslot.club_event_job_signups.length);
                return timeslot.number_required > timeslot.club_event_job_signups.length;
            },
            numberOfMembersRequired(timeslot) {
                console.log(timeslot.number_required - timeslot.club_event_job_signups.length);
                return timeslot.number_required - timeslot.club_event_job_signups.length;
            }
        },
    }
</script>
